/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FunctionalScopeWithLabel
 */
export interface FunctionalScopeWithLabel {
    /**
     * 
     * @type {string}
     * @memberof FunctionalScopeWithLabel
     */
    globalScopeHumanId: string;
    /**
     * 
     * @type {string}
     * @memberof FunctionalScopeWithLabel
     */
    specificScopeHumanId: string;
    /**
     * 
     * @type {string}
     * @memberof FunctionalScopeWithLabel
     */
    label: string;
}

/**
 * Check if a given object implements the FunctionalScopeWithLabel interface.
 */
export function instanceOfFunctionalScopeWithLabel(value: object): value is FunctionalScopeWithLabel {
    if (!('globalScopeHumanId' in value) || value['globalScopeHumanId'] === undefined) return false;
    if (!('specificScopeHumanId' in value) || value['specificScopeHumanId'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function FunctionalScopeWithLabelFromJSON(json: any): FunctionalScopeWithLabel {
    return FunctionalScopeWithLabelFromJSONTyped(json, false);
}

export function FunctionalScopeWithLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FunctionalScopeWithLabel {
    if (json == null) {
        return json;
    }
    return {
        
        'globalScopeHumanId': json['globalScopeHumanId'],
        'specificScopeHumanId': json['specificScopeHumanId'],
        'label': json['label'],
    };
}

export function FunctionalScopeWithLabelToJSON(value?: FunctionalScopeWithLabel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'globalScopeHumanId': value['globalScopeHumanId'],
        'specificScopeHumanId': value['specificScopeHumanId'],
        'label': value['label'],
    };
}

